__turbopack_context__.v({
  "codeRedeemLink": "PlansScreen-module-scss-module__LUQq3W__codeRedeemLink",
  "container": "PlansScreen-module-scss-module__LUQq3W__container",
  "discountContainer": "PlansScreen-module-scss-module__LUQq3W__discountContainer",
  "discountLabel": "PlansScreen-module-scss-module__LUQq3W__discountLabel",
  "freeTrialLabel": "PlansScreen-module-scss-module__LUQq3W__freeTrialLabel",
  "subtitleLine": "PlansScreen-module-scss-module__LUQq3W__subtitleLine",
  "taxExclusionLabel": "PlansScreen-module-scss-module__LUQq3W__taxExclusionLabel",
  "title": "PlansScreen-module-scss-module__LUQq3W__title",
  "titleHighlight": "PlansScreen-module-scss-module__LUQq3W__titleHighlight",
  "titleWrapper": "PlansScreen-module-scss-module__LUQq3W__titleWrapper",
});
